import { useEffect } from "react";
import Loading from "../../components/Loading";
import { arrayMap, findItemByFiled } from "../../utils/array.utils";
import { useGetGroupCarInfoQuery } from "../../utils/carInfo.utils";
import { useGetAllCarInfoTypeQuery } from "../../utils/carInfoType.utils";
import { RenderFields, optionGen } from "../../utils/form.utils";
import { textCamelCase } from "../../utils/string.utils";

export default function ForwardField({ watch, control, errors, setValue }) {
  const forwarOnChange = watch("forward");
  const forwardPrice = watch("forward_price");

  useEffect(() => {
    if (Number(forwardPrice) < 0) {
      setValue("forward_price", 0);
    }
  }, [forwardPrice, setValue]);

  const { loading: parentLoading, data: parentData } = useGetGroupCarInfoQuery({
    query: ``,
    key: `GetParentGroupCarInfoForStockListAdd`
  });

  const { loading: typeLoading, data: typeData } = useGetAllCarInfoTypeQuery({
    query: ``,
    key: `GetTypeDataForStockListAdd`
  });

  function handleTypeId(slug) {
    return typeData?.length ? findItemByFiled(typeData, "slug", slug)?.id : null;
  }

  let typeIds = {};

  const typeSlugs = arrayMap(typeData, (item) => item?.slug) || [];

  typeSlugs.forEach((element) => {
    typeIds[textCamelCase(element)] = handleTypeId(element);
  });

  function handleParentData(name) {
    return parentData[name] ? optionGen(parentData[name]) : [];
  }

  const forwardOptions = handleParentData("company");

  let fields = [
    {
      label: "Forward",
      name: "forward",
      type: "select",
      placeholder: "Select a forwar company",
      col: { md: 6 },
      options: forwardOptions
    }
  ];

  if (forwarOnChange) {
    fields.push({
      label: "Forward Price",
      name: "forward_price",
      type: "number",
      placeholder: "Enter a forward price",
      col: { md: 6 },
      rules: { required: "This is required field!" }
    });
  }

  const isLoading = typeLoading || parentLoading;

  return (
    <>
      <Loading loading={isLoading} />
      {
        <RenderFields
          setValue={setValue}
          fields={fields}
          control={control}
          watch={watch}
          errors={errors}
        />
      }
    </>
  );
}
